import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { FileImportTryResponse, FileImportDetectResponse } from '../../../models/src/lib/file-import.model';

@Injectable({
  providedIn: 'root'
})
export class ImportService extends BaseService<any> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/import';
  }

  public getTypes = (): Observable<any> => {
      const usedUrl = this.getUrl(`${this.path}/types`);
      return (
        this._http.get(usedUrl)as Observable<Response<any>>
      ).pipe(map(({ data }) => data));

  };

  public import = (body: any, type: string): Observable<any> => {
    return (
      this.post(body, `${type}/do`) as Observable<any>
    );
  };

  public detectImport = (
    file: FormData
  ): Observable<FileImportDetectResponse> => {
    return (
      this.post(file, 'detect') as Observable<Response<FileImportDetectResponse>>
    ).pipe(map(({ data }) => data));
  };

  public tryImport = (file: FormData, type: string): Observable<FileImportTryResponse> => {
    return (
      this.post(file, `${type}/try`) as Observable<Response<FileImportTryResponse>>
    ).pipe(map(({ data }) => data));
  };
}
